import { useCallback, useEffect, useRef } from "react"

export default function ExpandingTextArea({placeholder, onChange, dynamicValue, minRows = 1, maxRows = 5, onFocus, onBlur}) {
    const textAreaRef = useRef(null)
    const ROW_HEIGHT = 28
    
    const resizeTextArea = useCallback(() => {
        if (!textAreaRef.current) return
        textAreaRef.current.style.height = "auto"
        let height = Math.max(minRows * ROW_HEIGHT, Math.min(maxRows * ROW_HEIGHT, textAreaRef.current.scrollHeight - 24))
        textAreaRef.current.style.height = `${height}px`
    }, [minRows, maxRows])

    useEffect(() => {
        resizeTextArea()
    }, [dynamicValue, resizeTextArea])

    useEffect(() => {
        resizeTextArea()
        window.addEventListener("resize", resizeTextArea)
        return () => window.removeEventListener("resize", resizeTextArea)
    }, [resizeTextArea])

    return(<textarea
        className="silent-scroll"
        placeholder={placeholder}
        value={dynamicValue}
        ref={textAreaRef}
        onChange={(e) => onChange?.(e.target.value)}
        onFocus={() => onFocus?.()}
        onBlur={() => onBlur?.()}
        style={{
            padding: '12px 8px'
        }}
      />)
}